import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isMqAnimatingUp';

export const fn: AppBarGuardType = (context) => context.mqUp === 1 && context.mqAction === 1;

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
